import { createContext, useContext } from 'react';

/* Канал тоста отдельно от компонента: так `useToast` можно звать откуда угодно,
   а файл с компонентом остаётся файлом с компонентом (иначе ломается hot-reload). */

export const ToastContext = createContext<(message: string) => void>(() => {});

/** Показать плашку-тост. Новый вызов перебивает предыдущий. */
export function useToast(): (message: string) => void {
    return useContext(ToastContext);
}
